import { render, staticRenderFns } from "./FamilyListItem.vue?vue&type=template&id=68a824f7&scoped=true&"
import script from "./FamilyListItem.vue?vue&type=script&lang=js&"
export * from "./FamilyListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a824f7",
  null
  
)

export default component.exports